export * from './post-zeit-unterart-request.interface';
export * from './post-zeit-unterart-response.interface';
export * from './post-zeit-unterart.shapes';
